import { useState, useRef } from 'react';
import { useClickOutside } from '../../../hooks/useClickOutside';

export const useDeepSearch = () => {
  const [deepSearch, setDeepSearch] = useState(false);
  const [webSearch, setWebSearch] = useState(false);
  const [composeMode, setComposeMode] = useState(false);

  // Multi-select: any combination of atlas/box/box-jobit/salesforce/tableau/
  // jo-website/image_generation can be active at once. Empty set = "All" (the
  // baseline — nothing specific picked). Deep Search and Compose are NOT
  // part of this set — they're separate, mutually exclusive modes (see
  // Chat.tsx's clearExclusiveModes/clearNonSourceModes). File Upload also
  // isn't part of this set (its membership signal lives in useFileUpload's
  // fileUploadMode) but IS combinable with everything here. Web Search is
  // fully agnostic — independent of every other mode.
  const [selectedSources, setSelectedSources] = useState<Set<string>>(new Set());

  const [isModeMenuOpen, setIsModeMenuOpen] = useState(false);
  const modeMenuRef = useRef<HTMLDivElement>(null);
  // The + button that toggles the menu; counts as inside so it can close it.
  const modeMenuTriggerRef = useRef<HTMLButtonElement>(null);

  useClickOutside([modeMenuRef, modeMenuTriggerRef], () => setIsModeMenuOpen(false), isModeMenuOpen);

  return {
    deepSearch,
    webSearch,
    composeMode,
    selectedSources,
    isModeMenuOpen,
    modeMenuRef,
    modeMenuTriggerRef,
    setDeepSearch,
    setWebSearch,
    setComposeMode,
    setSelectedSources,
    setIsModeMenuOpen,
  };
};
